import Vuex from 'vuex';
import Vue from 'vue';

import ModuleCommande from '../modules/commande/store/store';
import ModuleRecherche from '../modules/recherche/store/store';
import ModuleStock from '../modules/stock/store/store';
import ModuleEncour from '../modules/encour/store/store';
import ModuleSoumission from '../modules/soumission/store/store';
import ModuleFacture from '../modules/facture/store/store';
import ModuleTarif from '../modules/tarif/store/store';
import ModuleDefaut from '../modules/defaut/store/store';
import ModuleProduit from '../modules/produit/store/store';
import ModulePanier from '../modules/panier/store/store';
import ModuleClient from '../modules/client/store/store';
import ModuleAuthentification from '../modules/authentification/store/store';
import ModuleEchantillon from '../modules/echantillon/store/store';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        commande: ModuleCommande,
        recherche: ModuleRecherche,
        stock: ModuleStock,
        encour: ModuleEncour,
        soumission: ModuleSoumission,
        facture: ModuleFacture,
        tarif: ModuleTarif,
        application: ModuleDefaut,
        produit: ModuleProduit,
        panier: ModulePanier,
        client: ModuleClient,
        authentification: ModuleAuthentification,
        echantillon: ModuleEchantillon
    }
})
